/**
 * Persona helpers — shared between HubAgentsPage and HubAgentDetailPage.
 *
 * v1 avatars are initials in a colored circle (Slack-default style).
 * Color picked by hashing display_name. Cheap, no external dependency.
 * Joe can swap in real images later by uploading to
 * /brand/agent-avatars/<slug>.svg|png and setting agent_status.avatar_url.
 */

const TONES = [
  '#7c93ff', '#ffb47c', '#9be37c', '#ff7cb4',
  '#7ce6f0', '#e8d97c', '#c87cff', '#ffaf7c',
  '#7cffd0', '#ff7c7c', '#7cb8ff', '#d77cff',
]

function hashString(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return h
}

export function personaInitials(name: string): string {
  if (!name) return '·'
  const parts = name.trim().split(/[\s:_-]+/).filter(Boolean)
  if (parts.length === 0) return '·'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function personaTone(name: string): string {
  return TONES[Math.abs(hashString(name)) % TONES.length]
}

export function deptLabel(d: string): string {
  switch (d) {
    case 'cs':
      return 'Customer Success'
    case 'qa':
      return 'QA'
    case 'eng':
      return 'Engineering'
    case 'exec':
      return 'Executive'
    default:
      return d.charAt(0).toUpperCase() + d.slice(1)
  }
}

export const DEPT_ORDER = ['exec', 'eng', 'marketing', 'sales', 'cs', 'support', 'qa']
